import axios, {AxiosResponse} from 'axios'
import {EvidenceQueryResponse} from '../../../models/IEvidence'

const API_URL = process.env.REACT_APP_BASE_API_URL
const URL = `${API_URL}/evidences`

const getEvidences = (query: string): Promise<EvidenceQueryResponse> => {
  return axios.get(`${URL}?${query}`).then((d: AxiosResponse<EvidenceQueryResponse>) => d.data)
}

export {getEvidences}
